import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { DashCard } from "../../../../script/components/dash-board/dash-card/dash-card";
import { CommChart } from "../../../../script/components/chart/charts";
import { CommAxis, CommArgs, BarsSeri, SBarSeri, AreaSeri, SpinSeri } from "../../../../script/components/chart/charts-item";
import { fwUtil } from "../../../../script/util";

export function DashOperCard(props) {
    const { loading, data, equiMont } = props;

    const [maindata, setMaidata] = useState([]);
    const maindataUpdate = useCallback((e) => setMaidata(e), []);
    const [argsDaysList, setArgsDaysList] = useState([]);
    const argsDaysListUpdate = useCallback((e) => setArgsDaysList(e), []);

    const getDayArray = useCallback((equiMont) => {
        const [year, month] = equiMont.split('-').map(Number);
        const daysInMonth = new Date(year, month, 0).getDate();
        return Array.from({ length: daysInMonth }, (_, i) => String(i + 1).padStart(2, '0'));
    }, []);

    useEffect(() => {
        argsDaysListUpdate(getDayArray(equiMont));
    }, [equiMont, argsDaysListUpdate, getDayArray]);

    useEffect(() => {
        const newData = [];
        for (let i = 0; i < argsDaysList.length; i++) {
            const argsDays = argsDaysList[i];
            let items = { args_days: argsDays, sens_val3: 0 };
            data.forEach(rows => {
                const day = rows.sens_date.split('-')[2];
                if (day === argsDays) { items = { ...items, ...rows } }
            });
            newData.push(items);
        }
        maindataUpdate(newData);
    }, [data, argsDaysList, maindataUpdate]);

    const tooltipTamplate = (arg) => {
        let strText = `${arg.argumentText}일 : ${fwUtil.conv.to.krLocales(arg.value)} (W)`;
        return { text: strText };
    };

    return (
        <DashCard
            title={"설비 가동 현황"}
            addClass={'oper'}
            loading={loading}
        >
            <CommChart
                dataSource={maindata}
                tooltip={{ location: "edge", template: tooltipTamplate }}
            >
                {CommAxis({ name: "axis_elec", caption: "일평균 사용전력(W)", position: "left", start: 0 })}
                {AreaSeri({ valueField: "sens_val3", caption: "일평균사용전력", color: "#FDE910", args: "args_days", axis: "axis_elec" })}
                {SpinSeri({ valueField: "sens_val3", caption: "일평균사용전력", color: "#FF6347", args: "args_days", axis: 'axis_elec' })}
            </CommChart>
        </DashCard>
    )
}